const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

export const authStorage = {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },

  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  },

  getUser(): string | null {
    return localStorage.getItem(USER_KEY);
  },

  setUser(username: string): void {
    localStorage.setItem(USER_KEY, username);
  },

  clearAuth(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  getRoles(): string[] {
    const token = this.getToken();
    if (!token) return [];
    try {
      const [, payloadPart] = token.split('.');
      if (!payloadPart) return [];
      const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64 + '==='.slice((base64.length + 3) % 4);
      const json = atob(padded);
      const payload = JSON.parse(json);
      
      // ClaimTypes.Role trong .NET thành "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      const roleKey = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
      const roles = payload[roleKey] ?? payload['role'] ?? payload['roles'] ?? [];
      return Array.isArray(roles) ? roles : [roles].filter(Boolean);
    } catch {
      return [];
    }
  },

  isAdmin(): boolean {
    return this.getRoles().includes('Admin');
  },
};
